module.exports = __webpack_public_path__ + "img/09-install-step-4-install.ff832aa6.webp";